/*
 * @Author: zhao - 🍉
 * @Date: 2021-12-17 14:42:35
 * @LastEditTime: 2021-12-29 16:49:15
 * @LastEditors: zhao - 🍉
 * @Description: 商户对账
 * @FilePath: /zhzj-admin/src/services/accountingRecord.js
 */

import { API_NAME } from "../axios/config";
import request from "../utils/request";

/**
 * 对账列表
 */
export function fetchAccountingRecordList(data) {
  return request({
    url: '/platform/merchantAccountingRecordLog/findPage',
    method: 'post',
    data
  })
}

/**
 * 对账 - 新增
 */
export function fetchAccountingRecordAdd(data) {
  return request({
    url: '/platform/merchantAccountingRecordLog/create',
    method: 'post',
    data
  })
}

export function fetchCreateDetailsLog(data){
    return request({
        url: '/platform/merchantTransferRecordLog/createDetailsLog',
        method: 'post',
        data
    })
}

/**
 * 对账 - 修改
 */
export function fetchAccountingRecordUpdate(data) {
  return request({
    url: '/platform/merchantAccountingRecordLog/update',
    method: 'post',
    data
  })
}

/**
 * 对账 - 获取
 */
export function fetchAccountingRecordGet(params) {
  return request({
    url: '/platform/merchantAccountingRecordLog/getInfo',
    method: 'post',
    params
  })
}

/**
 * 对账 - 获取租金汇集明细确认书
 */
export function fetchAccountingRecordBillConfirmLog(params) {
    return request({
        url: '/platform/merchantAccountingRecordLog/getAccountingRecordBillConfirmLog',
        method: 'post',
        params
    })
}

/**
 * 对账 - 导出租金汇集明细确认书
 */
export const apiAccountingRecordBillConfirmExport = API_NAME + '/platform/merchantAccountingRecordLog/exportRentCollectionDetailsConfirmLog'

/**
 * 对账 - 获取租金汇集明细
 */
export function fetchAccountingRecordCompilationDetails(params) {
    return request({
        url: '/platform/merchantAccountingRecordLog/getRentCompilationDetails',
        method: 'post',
        params
    })
}

/**
 * 对账 - 导出租金汇集明细
 */
export const apiAccountingRecordCompilationExport = API_NAME + '/platform/merchantAccountingRecordLog/exportRentCollectionDetails'

/**
 * 对账 - 获取到账确认书详情数据
 */
export function fetchAccountingRecordReceiptConfirmationDetails(params) {
    return request({
        url: '/platform/merchantAccountingRecordLog/getReceiptConfirmationDetails',
        method: 'post',
        params
    })
}
/**
 * 对账 - 导出到账确认书详情数据
 */
export const apiAccountingRecordReceiptConfirmationExport = API_NAME + '/platform/merchantAccountingRecordLog/exportReceiptConfirmationDetails'

/**
 * 对账 - 获取退款确认书详情数据
 */
export function fetchAccountingRecordRefundConfirmation(params) {
    return request({
        url: '/platform/merchantAccountingRecordLog/getRefundConfirmation',
        method: 'post',
        params
    })
}

/**
 * 对账 - 导出退款确认书详情数据
 */
export const apiAccountingRecordRefundConfirmationExport = API_NAME + '/platform/merchantAccountingRecordLog/exportRefundConfirmation'


/**
 * 对账 - 导出代偿确认书详情数据
 */
export const apiAccountingRecordConfirmationCompensationExport = API_NAME + '/platform/merchantAccountingRecordLog/exportConfirmationCompensation'

/**
 * 对账 - 获取商户对账审批流程列表
 */
export function fetchAccountingRecordFlowList(data) {
    return request({
        url: '/platform/merchantAccountingRecordLog/getFlowList',
        method: 'post',
        data
    })
}

/**
 * 对账 - 清除对账确认书配置
 */
export function fetchAccountingRecordClearConfirmation(data) {
    return request({
        url: '/platform/merchantAccountingRecordLog/clearConfirmation',
        method: 'post',
        data
    })
}
/**
 * 对账 - 初始化对账确认书配置
 */
export function fetchAccountingRecordInitConfirmation(data) {
    return request({
        url: '/platform/merchantAccountingRecordLog/initConfirmation',
        method: 'post',
        data
    })
}


/**
 * 对账 - 商户对账单->发起流程
 */
export function fetchAccountingRecordInitialProcess(data) {
    return request({
        url: '/platform/merchantAccountingRecordLog/initialProcess',
        method: 'post',
        data
    })
}

/**
 * 对账 - 商户对账单->撤回流程
 */
export function fetchAccountingRecordRevokeProcess(data) {
    return request({
        url: '/platform/merchantAccountingRecordLog/revokeProcess',
        method: 'post',
        data
    })
}

/**
 * 对账 - 商户对账单->确认流程 (商户端专用)
 */
export function fetchAccountingRecordConfirmationProcess(params) {
    return request({
        url: '/platform/merchantAccountingRecordLog/confirmationProcess',
        method: 'post',
        params
    })
}

/**
 * 对账 - 商户对账单->确认流程->发送短信验证码 (商户端专用)
 */
export function fetchAccountingRecordConfirmationSendVerifyCode(params) {
    return request({
        url: '/platform/merchantAccountingRecordLog/sendVerifyCode',
        method: 'post',
        params
    })
}

/**
 * 对账 - 商户对账单->发起云贷划账申请
 */
export function fetchAccountingRecordSponsorCloudLoansPayApplyFor(data) {
    return request({
        url: '/platform/merchantAccountingRecordLog/sponsorCloudLoansPayApplyFor',
        method: 'post',
        data
    })
}
/**
 * 对账 - 商户对账单->发起业主租金划账申请
 */
export function fetchAccountingRecordSponsorOwnerRentApplyFor(data) {
    return request({
        url: '/platform/merchantAccountingRecordLog/sponsorOwnerRentApplyFor',
        method: 'post',
        data
    })
}

/**
 * 对账 - 商户对账单->发起平台运营费用划账申请
 */
export function fetchAccountingRecordSponsorPlatformOperateApplyFor(data) {
    return request({
        url: '/platform/merchantAccountingRecordLog/sponsorPlatformOperateApplyFor',
        method: 'post',
        data
    })
}





// WEBPACK FOOTER //
// ./src/services/accountingRecord.js